/**
 * Two-layer star decoration with shadow effect
 *
 * Renders a decorative star with black shadow and white top layer.
 * Used across all road sections for visual consistency.
 */

import { ROAD_COLORS } from './constants/colors';

interface StarDecorationProps {
  x: number;
  y: number;
}

export function StarDecoration({ x, y }: StarDecorationProps) {
  return (
    <g transform={`translate(${String(x)}, ${String(y)})`}>
      {/* Star decoration - black shadow layer */}
      <path
        d="M0 0L-7.1 -11.67C-7.79 -12.8 -9.43 -12.77 -10.08 -11.62L-16.83 0.26L-30.13 2.86C-31.41 3.11 -31.9 4.69 -31.01 5.7L-21.8 16.09L-23.91 29.71C-24.07 31.03 -22.72 32.03 -21.49 31.54L-8.83 26.41L3.78 32.19C5 32.72 6.35 31.79 6.26 30.47L4.65 16.84L13.76 6.45C14.62 5.45 14.09 3.89 12.81 3.63L0 0Z"
        fill={ROAD_COLORS.shadowBlack}
      />
      {/* Star decoration - white top layer (slightly offset) */}
      <path
        d="M-0.05 -1.3L-7.15 -13.03C-7.84 -14.16 -9.48 -14.13 -10.13 -12.98L-16.88 -1.09L-30.18 1.51C-31.46 1.76 -31.95 3.34 -31.06 4.35L-21.85 14.74L-23.96 28.36C-24.12 29.68 -22.77 30.68 -21.54 30.19L-8.88 25.06L3.73 30.84C4.95 31.37 6.3 30.44 6.21 29.12L4.6 15.49L13.71 5.1C14.57 4.1 14.04 2.54 12.76 2.28L-0.04 -1.31L-0.05 -1.3Z"
        fill={ROAD_COLORS.white}
      />
    </g>
  );
}
